export let saturdayAbbreviatedLowercase = "jSvQ1";
export default {saturdayAbbreviatedLowercase};